import { PublicLink } from "./components/PublicLink";
import "./editorial/publication-polish.css";
import LegacyRegistryApp from "./LegacyRegistryApp";
import { DraftBar, SiteFooter, SiteHeader, getPath, route, useMetadata } from "./editorial/EditorialShell";
import { renderEditorialPage } from "./editorial/EditorialPages";

function isRegistryPath(path: string) {
  return path === "registry" || path === "registry/evidence" || path === "registry/testing"
    || path === "research/part-ii/evidence" || path === "research/part-ii/testing"
    || path === "evidence" || path === "testing";
}
function EditorialProgramme({ path }: { path: string }) {
  useMetadata(path);
  return <div className="v2-site plain-site">
    <PublicLink className="v2-skip-link" href="#main-content">Skip to content</PublicLink>
    <SiteHeader path={path} /><DraftBar />{renderEditorialPage(path)}<SiteFooter />
  </div>;
}
export default function EditorialApp() {
  const path = getPath();
  if (isRegistryPath(path)) return <>
    <nav className="publication-registry-return" aria-label="Return to the research programme">
      <PublicLink href={route()}>← Agency Transfer</PublicLink>
      <PublicLink href={route("research/part-ii/")}>Back to the evaluation review</PublicLink>
    </nav>
    <LegacyRegistryApp />
  </>;
  return <EditorialProgramme path={path} />;
}
